import React from "react";
import NavBar from "./NavBar";
import Sidebar from "../sidebar/Sidebar";

const ProfileLayout = ({ children }) => (
  <div style={{ width: "100%", minHeight: "100vh" }}>
    <NavBar />
    <div className="layout-container">
      <Sidebar />
      <main style={{ flexGrow: 1, width: "100%" }}>{children}</main>
    </div>
  </div>
);

export default ProfileLayout;
